import "echarts/lib/chart/line";

import Bar from "./Bar";

class Line extends Bar {
  chartType: string = "line";
}

export default Line;
